import { toArray } from '@wix/wow-utils';
const name = 'BaseBgParallaxY';
const properties = {
    hideOnStart: false,
    groups: ['animation', 'background', 'base'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        start: {
            type: 'number',
            min: 0,
            max: 1,
        },
        end: {
            type: 'number',
            min: 0,
            max: 1,
        },
        ease: {
            type: 'string',
        },
        componentHeight: {
            type: 'number',
            min: 0,
        },
        viewPortHeight: {
            type: 'number',
            min: 0,
        },
        speedFactor: {
            type: 'number',
        },
    },
};
/**
 * Base Parallax for balata media elements on scroll
 */
function animate(kit, elements, duration, delay, { speedFactor, start, end, ease, componentHeight, viewPortHeight, ...params } = {}) {
    elements = toArray(elements);
    const sequence = kit.sequence(params);
    elements.forEach((element) => {
        element.style.willChange = 'transform';
    });
    const from = -viewPortHeight * speedFactor;
    const to = componentHeight * speedFactor;
    const travel = to - from;
    sequence.add(kit.animate('BaseBgPositionY', elements, duration, delay, {
        from: from + travel * start,
        to: to - travel * (1 - end),
        start,
        end,
        ease,
    }), 0);
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=baseBgParallaxY.js.map